import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { useObservable } from './rxjs';
export function useIsBackgrounded(videoController) {
    const backgrounded = videoController.pipe(switchMap(controller => {
        return controller?.backgrounded ?? of(false);
    }));
    return useObservable(backgrounded);
}
//# sourceMappingURL=use_is_backgrounded.js.map